import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInView } from '../hooks/useInView';

export default function Skills() {
  const [ref, inView] = useInView();
  const { t } = useTranslation();
  const groups = t('skills.groups', { returnObjects: true });

  return (
    <section id="skills" className={`section skills${inView ? ' in-view' : ''}`} ref={ref}>
      <div className="section__container">
        <h2 className="section__title">{t('skills.title')}</h2>
        <div className="skills__grid">
          {groups.map(({ category, skills }) => (
            <div key={category} className="skills__group">
              <h3 className="skills__category">{category}</h3>
              <div className="skills__tags">
                {skills.map(skill => (
                  <span key={skill} className="tag">{skill}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
